/**
 * Whether to show an image or a video.
 */
export var MediaItemType;
(function (MediaItemType) {
    MediaItemType["unknown"] = "unknown";
    MediaItemType["image"] = "image";
    MediaItemType["video"] = "video";
})(MediaItemType || (MediaItemType = {}));
//# sourceMappingURL=media-item-type.js.map